module.exports = __webpack_public_path__ + "img/ARCH_06.2002dbd9.jpg";